module.exports = __webpack_public_path__ + "img/vantagens.b2d1b203.svg";